import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PrintResult } from '../../../../nextray/Utils/PrintUtils';
import { Plan } from '../../../core';
import { BaseComponent } from '../../../shared';
import { PrtMaApTableComponent, PrtMaLtTableComponent } from '../prt-ma-tables';
import { PrtTemplateComponent } from '../prt-template';


/**
* First page of PDF print.
*/
@Component({
	selector: 'print-page-one',
	templateUrl: './page-one.component.html',
	imports: [
		PrtTemplateComponent,
		PrtMaApTableComponent,
		PrtMaLtTableComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrintPageOneComponent extends BaseComponent implements OnInit {

	@Input() isDemo = false;
	@Input() today: Date | null = null;

	currentCase?: Plan;
	printResult?: PrintResult;


	ngOnInit(): void {
		this.currentCase = this.canvasSrv.currentCase;
		this.printResult = this.canvasSrv.printResult;
	}

}
